function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Stopwatch Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M8.468,3.4997 C10.6301077,3.4997 12.591113,4.36075584 14.0268068,5.75865842 C14.0429007,5.72086242 14.066745,5.685602 14.0956062,5.65305641 L15.0356062,4.59305641 C15.2188231,4.3864501 15.5348373,4.36748925 15.7414436,4.55070617 C15.9480499,4.73392309 15.9670108,5.04993727 15.7837938,5.25654359 L14.8437938,6.31654359 C14.7904522,6.37669479 14.7258544,6.42094078 14.6559774,6.44892293 C15.7696011,7.8175598 16.437,9.56519331 16.437,11.4687 C16.437,15.8698424 12.8691424,19.4377 8.468,19.4377 C4.0675226,19.4377 0.499,15.8695074 0.499,11.4687 C0.499,7.06789261 4.0675226,3.4997 8.468,3.4997 Z M8.468,4.4997 C4.61978665,4.4997 1.499,7.62019807 1.499,11.4687 C1.499,15.3172019 4.61978665,18.4377 8.468,18.4377 C12.3168576,18.4377 15.437,15.3175576 15.437,11.4687 C15.437,7.61984237 12.3168576,4.4997 8.468,4.4997 Z M8.4849,6.5 C8.76104237,6.5 8.9849,6.72385763 8.9849,7 L8.9849,11 C8.9849,11.2761424 8.76104237,11.5 8.4849,11.5 C8.20875763,11.5 7.9849,11.2761424 7.9849,11 L7.9849,7 C7.9849,6.72385763 8.20875763,6.5 8.4849,6.5 Z M6.52895971,0.499999908 L10.4129597,0.516004242 C10.6890997,0.517141791 10.9120333,0.741919683 10.9109001,1.01805971 C10.9097582,1.29419975 10.6849803,1.51713331 10.4088403,1.51600009 L6.52484029,1.49999991 C6.24870025,1.49885821 6.02576669,1.27408032 6.02689991,0.997940285 C6.02804179,0.721800253 6.25281968,0.498866693 6.52895971,0.499999908 Z",
  id: "stopwatch-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "stopwatch-Icon/Global/stopwatch",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "stopwatch-Swatches/DarkGreen",
  transform: "translate(4.000000, 2.000000)"
}, /*#__PURE__*/React.createElement("use", {
  id: "stopwatch-Mask",
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#stopwatch-path-1"
})));

var SvgStopwatch = function SvgStopwatch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStopwatch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/stopwatch.463bf758.svg";
export { ForwardRef as ReactComponent };